import React from 'react';
import Select from 'components/Core/Select';

const CustomerResourceHubFilters = ({ setValues, values }) => {
  const onHandleChange = (id, newValue) => {
    setValues((prevValues) => ({
      ...prevValues,
      [id]: newValue,
    }));
  };

  const businessFocusOptions = [
    { label: 'All Business Focuses', value: 'All Business Focuses' },
    { label: 'Residential S/R', value: 'Residential S/R' },
    { label: 'Commercial S/R', value: 'Commercial S/R' },
    { label: 'Residential Construction', value: 'Residential Construction' },
    { label: 'Commercial Construction', value: 'Commercial Construction' },
  ];

  const personasOptions = [
    { label: 'All Personas', value: 'All Personas' },
    { label: 'Owner', value: 'Owner' },
    { label: 'Admin', value: 'Admin' },
    { label: 'GM/OPS Manager', value: 'GM/OPS Manager' },
    { label: 'Field Manager', value: 'Field Manager' },
    { label: 'Dept Manager', value: 'Dept Manager' },
    { label: 'Accounting', value: 'Accounting' },
    { label: 'Dispatch/CSR', value: 'Dispatch/CSR' },
    { label: 'Technician', value: 'Technician' },
  ];

  const productsOptions = [
    { label: 'All Products', value: 'All Products' },
    { label: 'Pro Products', value: 'Pro Products' },
  ];

  return (
    <div className="max-w-[1258px] pt-0 px-[28px] mt-0 mb-10 md:mb-14 mx-auto">
      <Select
        id="focus"
        placeholder="Business Focus"
        options={businessFocusOptions}
        formValid={null}
        handleChange={onHandleChange}
        className="!pb-4 md:!pb-0 md:max-w-[220px] lg:max-w-[248px]"
        value={values?.focus}
      />
      <Select
        id="personas"
        placeholder="Persona"
        options={personasOptions}
        formValid={null}
        handleChange={onHandleChange}
        className="!pb-4 md:!pb-0 md:!ml-5 md:max-w-[220px] lg:max-w-[248px]"
        value={values?.personas}
      />
      <Select
        id="products"
        placeholder="Products"
        options={productsOptions}
        formValid={null}
        handleChange={onHandleChange}
        className="!pb-4 md:!pb-0 md:!ml-5 md:max-w-[220px] lg:max-w-[248px]"
        value={values?.products}
      />
    </div>
  );
};

export default CustomerResourceHubFilters;
